export const EDIT_WORKFLOW = {

  'MODAL': {
    'CONTENT': 'Do you really want to delete this workflow? This action is irreversible.'
  }

};
